export const browseSupplyActions = {
  BROWSE_SUPPLY_SEARCH_LOADING: 'BROWSE_SUPPLY_SEARCH_LOADING',
  BROWSE_SUPPLY_SEARCH_SUCCESS: 'BROWSE_SUPPLY_SEARCH_SUCCESS',
  BROWSE_SUPPLY_SEARCH_FAILURE: 'BROWSE_SUPPLY_SEARCH_FAILURE',

  ADD_TEMP_EDITED_BRANDS: "ADD_TEMP_EDITED_BRANDS",
  REMOVE_TEMP_EDITED_BRANDS: "REMOVE_TEMP_EDITED_BRANDS",
  RESET_TEMP_EDITED_BRANDS: "RESET_TEMP_EDITED_BRANDS",
  RESET_SEARCHED_PROPERTIES: "RESET_SEARCHED_PROPERTIES",
}